import { ObservableArray, View } from "binder"
import { PublishViewModel, customService, report, process, Feature } from "./publish-viewModel"

export class PublishView extends View<PublishViewModel>{
    GetViewUniqueId(): string {
        return "V-D32BD44F-2FEB-4FFC-BEF2-E3E296123B98"
    }
    loadHtml(): string {
        let element = require('./publish.html').default;
        let style = require('./publish.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set hostAddress(v: string) { this._hostAddress = v; } public get hostAddress(): string { return this._hostAddress;} private _hostAddress: string;
    
    public set processes(v: ObservableArray<process>) { this._processes = v; } public get processes(): ObservableArray<process> { return this._processes;} private _processes: ObservableArray<process>;
    public set customServices(v: ObservableArray<customService>) { this._customServices = v; } public get customServices(): ObservableArray<customService> { return this._customServices;} private _customServices: ObservableArray<customService>;
    public set reports(v: ObservableArray<report>) { this._reports = v; } public get reports(): ObservableArray<report> { return this._reports;} private _reports: ObservableArray<report>;

    public set selectAllReports(v: boolean) { this._selectAllReports = v; } public get selectAllReports(): boolean { return this._selectAllReports;} private _selectAllReports: boolean;
    public set selectAllProcesses(v: boolean) { this._selectAllProcesses = v; } public get selectAllProcesses(): boolean { return this._selectAllProcesses;} private _selectAllProcesses: boolean;
    public set selectAllCustomServices(v: boolean) { this._selectAllCustomServices = v; } public get selectAllCustomServices(): boolean { return this._selectAllCustomServices;} private _selectAllCustomServices: boolean;
    public set features(v: ObservableArray<Feature>) { this._features = v; } public get features(): ObservableArray<Feature> { return this._features;} private _features: ObservableArray<Feature>;
    public set reorderMenus(v: boolean) { this._reorderMenus = v; } public get reorderMenus(): boolean { return this._reorderMenus;} private _reorderMenus: boolean;
    
    publish(){
        this.dataContext.publish();
    }
    addFeature(){
        this.dataContext.addFeature();
    }
}
